import type { App, Component } from 'vue'

// Button
import SButton from './button/index.vue'
export { SButton }

// Input
import SInput from './input/index.vue'
export { SInput }

// Dialog
import SDialog from './dialog/index.vue'
export { SDialog }

// Select
import SSelect from './select/index.vue'
export { SSelect }

// BannerCarousel
import SBannerCarousel from './banner-carousel/index.vue'
export { SBannerCarousel }
export type { BannerItem, BannerCarouselProps, BannerCarouselEmits } from './banner-carousel/banner-carousel.types'

// Form
import SForm from './form/SForm.vue'
import SFormItem from './form/SFormItem.vue'
export { SForm, SFormItem }
export type {
    FormProps,
    FormItemProps,
    FormRule,
    FormRules,
    ValidateResult,
    FormExpose,
    FormItemExpose,
} from './form/form.types'

// Pagination
import SPagination from './pagination/index.vue'
export { SPagination }

// CountBadge
import SCountBadge from './count-badge/index.vue'
export { SCountBadge }

// 所有组件
const components: Record<string, Component> = {
    SButton,
    SInput,
    SDialog,
    SSelect,
    SBannerCarousel,
    SForm,
    SFormItem,
    SPagination,
    SCountBadge,
}

// 全局注册插件
export function install(app: App): void {
    Object.entries(components).forEach(([name, component]) => {
        app.component(name, component)
    })
}

// 默认导出插件
export default {
    install,
}
